import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  listContainers(agroexporter_id) {
    return RequesterV1.get(
      "open_queries/agroexporter/basic_production_list/" + agroexporter_id
    );
  },
  listPallets(container_id) {
    return RequesterV1.get(
      "open_queries/agroexporter/basic_production_details/" + container_id
    );
  }
};
